import * as React from 'react'
import { FC } from 'react'
import { useUpdateFilialMutation } from '@services/filials'
import useFormProcessor from '@hooks/useFormProcessor'
import { Option } from '@organisms/Select'
import { FilialDetailed, UpdateFilialBody } from '@models/filial'
import CommissionMemberMultilineFields from '@templates/CommissionMemberMultilineFields'
import RiskMemberMultilineFields from '@templates/RiskMemberMultilineFields'
import { User } from '@models/user'
import { getMultilineValue } from '@utils/form'
import LineFields from '@templates/AddNewItemModal/Content/LineFields'
import {
  filialLegalFields,
  filialProtocolFields,
} from '@modals/FilialModal/useFilialFields'
import getDefaultValues from '@modals/FilialModal/getDefaultValues'
import AddNewItemModalLayout from '@templates/AddNewItemModalLayout'

export type FormValues = {
  commissionHead: Option
  commissionMembers: Option[]
  riskMapCommissionMembers?: User[]
  protocolOrderDate?: string
  protocolOrderNumber?: string
  ogrn?: string
  legalAddress?: string
}

type Props = {
  filialInfo: FilialDetailed
}

const EditFilialBlock: FC<Props> = ({ filialInfo }) => {
  const [update, updateData] = useUpdateFilialMutation()

  const methods = useFormProcessor({
    apiErrors: updateData.error,
    defaultValues: getDefaultValues(filialInfo),
  })

  const handleSubmitForm = (form: FormValues) => {
    if (!filialInfo) {
      return
    }

    const formBody: UpdateFilialBody = {
      company: filialInfo.company['@id'],
      title: filialInfo.title,
      fullTitle: filialInfo.fullTitle,
      subscriptionsCount: filialInfo.subscriptionsCount || null,
      subscriptionStartAt: filialInfo.subscriptionStartAt || null,
      subscriptionEndAt: filialInfo.subscriptionEndAt || null,
      curators: getMultilineValue(filialInfo.curators),
      inn: filialInfo.inn || null,
      commissionMembers: getMultilineValue(form.commissionMembers),
      commissionHead: form.commissionHead?.value || null,
      id: filialInfo.id,
      riskMapCommissionMembers: getMultilineValue(
        form.riskMapCommissionMembers
      ),
      protocolOrderDate: form.protocolOrderDate,
      protocolOrderNumber: form.protocolOrderNumber,
      ogrn: form.ogrn,
      legalAddress: form.legalAddress,
    }

    update(formBody)
  }

  return (
    <AddNewItemModalLayout
      {...updateData}
      onSubmitForm={handleSubmitForm}
      methods={methods}
      successContentAddTitle="Настройки филиала успешно обновлены"
      withNotificationBanner
      withoutReset
    >
      <LineFields
        fields={filialProtocolFields}
        lineTitle="Члены комиссии и председатель"
      />
      <CommissionMemberMultilineFields />
      <RiskMemberMultilineFields />
      <LineFields
        fields={filialLegalFields}
        lineTitle="Юридическая информация"
      />
    </AddNewItemModalLayout>
  )
}

export default EditFilialBlock
